/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PriceChartResponse } from '../../models/price-chart-response';

export interface GetPriceChart$Params {
  location_id: string;
  aggregation?: string;
  at?: string;
}

export function getPriceChart(http: HttpClient, rootUrl: string, params: GetPriceChart$Params, context?: HttpContext): Observable<StrictHttpResponse<PriceChartResponse>> {
  const rb = new RequestBuilder(rootUrl, getPriceChart.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('aggregation', params.aggregation, {});
    rb.query('at', params.at, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PriceChartResponse>;
    })
  );
}

getPriceChart.PATH = '/locations/{location_id}/price-chart';
